import MuiAlert from "@mui/material/Alert";


Alert.Error = ({ errors }) => {
	return errors && (
		<MuiAlert variant="filled" severity="error">
			{errors?.map(e => e)}
		</MuiAlert>
	);
};

export default function Alert (props) {
	return <MuiAlert {...props} />;
}